import {Pipe, PipeTransform} from '@angular/core';
import {CommunicationTypesEnum} from "../../Shared/Enum/communication-types.enum";

@Pipe({
  name: 'communicationTitle',
  standalone: false
})
export class CommunicationTitlePipe implements PipeTransform {

  transform(type?: number): string {

    if (!type) {
      return 'COMMUNICATION.TITLE';
    }

    switch (type) {
      case CommunicationTypesEnum.events:
        return 'COMMUNICATION.EVENTS';

      case CommunicationTypesEnum.meetings:
        return 'COMMUNICATION.MEETINGS';

      case CommunicationTypesEnum.warnings:
        return 'COMMUNICATION.WARNINGS';

      case CommunicationTypesEnum.breakdowns:
        return 'COMMUNICATION.BREAKDOWNS';

      case CommunicationTypesEnum.chats:
        return 'COMMUNICATION.CHATS';

      case CommunicationTypesEnum.lists:
        return 'COMMUNICATION.LISTS';

      default:
        return 'COMMUNICATION.TITLE';
    }

  }

}
